import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Music2, Youtube } from "lucide-react";
import { footer } from "../mock";

const ICONS = { Instagram, Music2, Youtube };

const legal = [
  { label: "Impressum", to: "/impressum" },
  { label: "Datenschutz", to: "/datenschutz" },
  { label: "Kontakt", to: "/kontakt" },
];

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-black/20 py-12">
      <div className="mx-auto flex max-w-[1500px] flex-col gap-8 px-5 md:px-10">
        <div className="flex flex-col items-center gap-7 text-center">
          <Link to="/" className="flex items-center">
            <img src="/crtr-logo-long.png" alt="CRTR Studios" className="h-7 w-auto" />
          </Link>
          <nav className="flex flex-wrap justify-center gap-7">
            {footer.nav.map((n) => (
              <a key={n.label} href={n.href} className="mono-label text-xs text-white/70 transition-colors hover:text-[var(--crtr-yellow)]">{n.label}</a>
            ))}
            <a href="mailto:info@all-about-artists.de" className="mono-label text-xs text-white/70 transition-colors hover:text-[var(--crtr-yellow)]">LET’S TALK</a>
          </nav>
          <div className="flex justify-center gap-3">
            {footer.socials.map((s) => {
              const Icon = ICONS[s.icon];
              return (
                <a key={s.icon} href={s.url} target="_blank" rel="noreferrer" aria-label={s.icon} data-testid={`footer-social-${s.icon.toLowerCase()}`} className="flex h-9 w-9 items-center justify-center rounded-full border border-white/20 text-white/70 transition-colors hover:border-[var(--crtr-yellow)] hover:text-[var(--crtr-yellow)]">
                  <Icon className="h-4 w-4" />
                </a>
              );
            })}
          </div>
        </div>
        <div className="flex flex-col items-center gap-4 border-t border-white/10 pt-6">
          <div className="flex flex-wrap items-center justify-center gap-6">
            {legal.map((l) => (
              <Link key={l.to} to={l.to} className="mono-label text-[11px] text-white/60 transition-colors hover:text-[var(--crtr-yellow)]">
                {l.label}
              </Link>
            ))}
          </div>
          <span className="mono-label text-[11px] text-white/40">{footer.copyright}</span>
        </div>
      </div>
    </footer>
  );
}
